// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"615108c4","455":"2813b89c","977":"1b9d8bca"}[chunkId] + ".chunk.js";
};